export const addTask = (task) => ({
    type: 'TASK_ADD',
    payload: task,
});
export const updateTaskStatus = (taskId, status, result) => ({
    type: 'TASK_UPDATE_STATUS',
    payload: { taskId, status, result },
});
export const setTasks = (tasks) => ({
    type: 'TASK_SET_ITEMS',
    payload: tasks,
});
export const removeTask = (taskId) => ({
    type: 'TASK_REMOVE',
    payload: { taskId },
});
export const openTaskSocketConnect = () => ({
    type: 'TASK_SOCKET_CONNECT',
});
export const closeTaskSocketConnect = () => ({
    type: 'TASK_SOCKET_DISCONNECT',
});
